module.exports = __webpack_public_path__ + "img/part_6_1.2c3c2e11.png";